import { render, staticRenderFns } from "./other-bill.vue?vue&type=template&id=0c4844fe&scoped=true&"
import script from "./other-bill.vue?vue&type=script&lang=js&"
export * from "./other-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4844fe",
  null
  
)

export default component.exports